var _defs, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "road",
    patternUnits: "userSpaceOnUse",
    width: 100,
    height: 100
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "#696969"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 0,
    width: 30,
    height: 100,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 0,
    width: 2,
    height: 20,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 40,
    width: 2,
    height: 20,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 80,
    width: 2,
    height: 20,
    fill: "white"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "url(#road)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoad);
export default __webpack_public_path__ + "static/media/road.1d40746d8b08c0a427a7a2d4dd6b0cef.svg";
export { ForwardRef as ReactComponent };